import { optionTitle_readSurfaceActions } from './ReadSurfaceActionsOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let ReadSurfaceActionsOption: LazyOption = createLazyOption(
    {
        key: 'readSurfaceActions',
        titleStringKey: optionTitle_readSurfaceActions,
        searchTermsStringKey: optionTitle_readSurfaceActions,
    },
    lazyFullModule,
    m => m.ReadFullSettings
);
export default ReadSurfaceActionsOption;
